var axios = require('axios')
const url = process.env.version2 + '/product-menu-fe'
const urlMenu = process.env.version2 + '/product-menu-fe/menu'
const urlMenuCombo = process.env.version2 + '/product-menu-fe/menu/'
const urlCategory = process.env.version2 + '/product-menu-fe/category'
const urlHalfFirst = process.env.version2 + '/product-menu-fe/first-layers'
const urlHalfSecond = process.env.version2 + '/product-menu-fe/second-layers'
const urlNutrition = process.env.version2 + '/product-menu-fe/'
const urlFriendlyNameSeo = process.env.version2 + '/product-menu-fe/menu-by-nameseo'

const urlMenuNew = process.env.host_menu + '/' + process.env.version2 + '/product-menu-fe/menu'
const urlCategoryNew = process.env.host_menu + '/' + process.env.version2 + '/product-menu-fe/category'
const urlMenuComboNew = process.env.host_menu + '/' + process.env.version2 + '/product-menu-fe/menu/'

const urlCutlery = process.env.version2 + '/product-menu-fe/cutlery'

axios.getHalf = function (type, data, success, callBackError) {
    var url = urlHalfFirst;
    if (type == 2) {
        url = urlHalfSecond;
    }

    this.get(url, {params: data})
        .then(response => {
            success(response)
        }).catch(error => {
        if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
            if (typeof callBackError !== 'undefined') {
                callBackError(error.response.data)
            }
        }
    })
}

axios.getMenuByCategory = function (data, success, callBackError) {
  axios.options.flag = true
  this.get(urlMenuNew, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getHutReward = function (data, success, callBackError) {
  this.get(url + '/hut-reward?', {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getDonation = function (data, success, callBackError) {
  this.get(url + '/donation?', {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuCombo = function (data, success, callBackError) {
  this.get(urlMenuComboNew, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getAddOnByCategory = function (data, success, callBackError) {
  this.get(url + '/add-on?', {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuDetails = function (uuid, data, success, callBackError) {
  this.get(urlMenuNew + '/' + uuid, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getComboDetails = function (uuid, data, success, callBackError) {
  axios.options.flag = true
  this.get(urlMenuComboNew + uuid, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getCutlery = function (data, success, callBackError) {
  axios.options.notify = data['isShowNotify'] ? data['isShowNotify'] : false
  this.get(urlCutlery, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getListCategory = function (data, success, callBackError) {
  axios.defaults.headers.common['Lang'] = data['lang'] || axios.defaults.headers.common['Lang']

  let url = urlCategoryNew + '?' + data
  this.get(url, data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getListHalf = function (data, success, callBackError) {
  axios.options.flag = false
  this.get(urlMenuNew, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getAllergey = function (data, success, callBackError) {
  axios.options.flag = true
  this.get(urlNutrition + 'allergens/' + data.id)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
axios.getNutrition = function (data, success, callBackError) {
  axios.options.flag = true
  this.get(urlNutrition + 'nutritions/' + data.id)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPromoBanner = function (key, success, callBackError) {
  axios.options.flag = true
  this.get(urlCategory + '/' + key)
      .then(response => {
        success(response)
      }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getComboDetailsFriendlyNameSeo = function (data, success, callBackError) {
  axios.options.flag = true
  this.get(urlFriendlyNameSeo, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Menu.js